// frontend/src/pages/StudentChapterTopics.js
import React, { useState, useEffect } from 'react';
import './studenttopiccontent.css';
import StudentTopicContent from './StudentTopicContent';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const resolveImageUrl = (path) => {
    if (!path) return '';
    return path.startsWith('http') ? path : `${API_BASE}/${path}`;
};

const StudentChapterTopics = ({ chapterId, chapterName, language = 'en', onBack }) => {
    const [topics, setTopics] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [openTopic, setOpenTopic] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(`${API_BASE}/content-page/chapter/${chapterId}/topics?language=${language}`);
                if (!res.ok) throw new Error('Failed to load topics');
                const data = await res.json();
                setTopics(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [chapterId, language]);

    if (openTopic) {
        return (
            <StudentTopicContent
                topicId={openTopic.card_id}
                topicName={openTopic.heading}
                language={language}
                onBack={() => setOpenTopic(null)}
            />
        );
    }

    return (
        <div className="stc-container">
            <div className="stc-header">
                {onBack && <button className="stc-back-btn" onClick={onBack}>&larr;</button>}
                <h2>{chapterName}</h2>
            </div>

            {error && <div className="stc-error">{error}</div>}

            {loading ? (
                <p>Loading...</p>
            ) : (
                <div className="stc-card-list">
                    {topics.map((topic) => (
                        <div key={topic.card_id} className="stc-card" onClick={() => setOpenTopic(topic)}>
                            {topic.feature_image_url && (
                                <img src={resolveImageUrl(topic.feature_image_url)} alt="" className="stc-card-image" />
                            )}
                            <div className="stc-card-body">
                                <h4>{topic.heading || '(untitled)'}</h4>
                                {topic.short_summary && <p>{topic.short_summary}</p>}
                            </div>
                        </div>
                    ))}
                    {topics.length === 0 && <p className="stc-empty">No topics available yet.</p>}
                </div>
            )}
        </div>
    );
};

export default StudentChapterTopics;